export const FeatureStatusList = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Hidden",
    value: "hidden",
  },
  {
    label: "Coming Soon",
    value: "comingSoon",
  },
];
